module.exports = __webpack_public_path__ + "img/partner-hover-4.580176e1.png";